export default [
  {
    path: "/live",
    name: "live_layout",
    component: () => import("./layout.vue"),
    children: [
      {
        path: "myliveroom",
        name: "myliveroom",
        meta: {
          title: "我的直播",
          requiresAuth: 1
        },
        component: () => import("./myliveroom.vue")
      },
      {
        path: "chkproject",
        name: "chkproject",
        meta: {
          title: "选择楼盘",
          requiresAuth: 1
        },
        component: () => import("./chkproject.vue")
      },
      {
        path: "createliveroom",
        name: "createliveroom",
        meta: {
          title: "编辑直播信息",
          requiresAuth: 1
        },
        component: () => import("./createliveroom.vue")
      },
      {
        path: "liveroominfo",
        name: "liveroominfo",
        meta: {
          title: "直播分享",
          requiresAuth: 1
        },
        component: () => import("./liveroominfo.vue")
      },
      {
        path: "liveshareguide",
        name: "liveshareguide",
        meta: {
          title: "分享直播",
          requiresAuth: 1 //0：静默授权，只能获取到openId 1：弹窗授权，用户昵称和openId都能获取到  2：不授权
        },
        component: () => import("./liveshareguide.vue")
      }
    ]
  }
];
